import React from 'react';
import { createPortal } from 'react-dom';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { FormGroup, FormControl, FormLabel, Row, Col } from 'react-bootstrap';
import { FiChevronDown, FiChevronRight, FiChevronUp, FiCornerUpLeft, FiCornerUpRight, FiGrid, FiInfo } from 'react-icons/fi';
import Switch from 'components/Switch';
import TimeInputWithArrows from 'components/TimeInputWithArrows';
import StaffingCatalogSelect from './StaffingCatalogSelect';
import { staffingLevelsService } from 'services';
import { getFirstLastInterval } from 'utils/datetime';
import { errorFormating } from 'utils/utils';
import SubmitButton from 'components/SubmitButton';
import ConfirmModal from 'components/Modal/types/ConfirmModal';
import * as groupsActions from 'actions/groupsActions';
import * as calendarsActions from 'actions/calendarsActions';
import * as ubicationsActions from 'actions/ubicationsActions';
import * as timesActions from 'actions/timesActions';
import { withTranslation } from 'react-i18next';
import {
	applyColumnClipboard,
	applyRowClipboard,
	applySlotUpdates,
	buildFractionRows,
	buildFractions,
	buildGridRows,
	cellFillStyle,
	gridPeak,
	cellKey,
	columnClipboard,
	filterCatalog,
	fractionsFromNeeds,
	fractionWindowFromNeeds,
	functionTotal,
	ubicationTotal,
	inferFractionSetup,
	rememberFractionNeeds,
	isFractionGridReady,
	isGridReady,
	normalizeCounter,
	orderedByCatalog,
	readSlotCounter,
	rowClipboard,
	syncStaffingNeeds,
	toSubmitPayload,
} from './staffingNeedGrid';

const HISTORY_LIMIT = 40;
const ASSIGN_DIGITS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

const DEFAULT_FRACTION_START = '08:00';
const DEFAULT_FRACTION_END = '20:00';
const DEFAULT_FRACTION_MINUTES = 60;

export const STAFFING_LEVEL_MODAL_STYLE = {
	width: '1200px',
	maxWidth: 'calc(100vw - 32px)',
	maxHeight: 'calc(100vh - 48px)',
	overflow: 'auto',
};

class StaffingLevelEdit extends React.Component {
	constructor(props) {
		super(props);

		let staffing_level = {
			name: '',
			description: '',
			needs: [],
			has_ubications: false,
		};

		let isEdit = false;
		let selected_functions = [];
		let selected_shifts = [];
		let selected_ubications = [];

		if (props.staffing_level) {
			isEdit = true;
			staffing_level = {
				...props.staffing_level,
				needs: props.staffing_level.needs || [],
				has_ubications: !!props.staffing_level.has_ubications,
			};
			const extracted = this.extractSelectedItems(staffing_level);
			selected_functions = extracted.selected_functions;
			selected_shifts = extracted.selected_shifts;
			selected_ubications = extracted.selected_ubications;
		}

		const fractionSetup = inferFractionSetup(staffing_level.needs);
		const savedFractions = fractionsFromNeeds(staffing_level.needs);
		const fractionWindow = fractionWindowFromNeeds(staffing_level.needs);
		const editorMode =
			savedFractions.length > 0 && selected_shifts.length === 0 ? 'fraction' : 'shift';

		this.state = {
			isEdit,
			isLoading: false,
			submitted: false,
			errors: {},
			staffing_level,
			editorMode,
			fractionStart: fractionSetup.start || DEFAULT_FRACTION_START,
			fractionEnd: fractionSetup.end || DEFAULT_FRACTION_END,
			fractionMinutes: fractionWindow.minutes || fractionSetup.minutes || DEFAULT_FRACTION_MINUTES,
			fractions:
				savedFractions.length > 0
					? fractionWindow.fractions
					: buildFractions(DEFAULT_FRACTION_START, DEFAULT_FRACTION_END, DEFAULT_FRACTION_MINUTES),
			selected_functions,
			selected_shifts,
			selected_ubications,
			activeFunctionId: selected_functions[0] ? selected_functions[0].id : null,
			brush: null,
			customBrush: '',
			clipboard: null,
			menu: null,
			editing: null,
			history: [],
			future: [],
			openCatalog: null,
			catalogQuery: '',
			collapsedLocations: {},
			fractionMemory: rememberFractionNeeds([], staffing_level.needs, []),
			pendingEditorMode: null,
		};

		this.painting = false;
		this.paintHistoryRecorded = false;
		this.lastPaintKey = null;
		this.paintValue = null;
		this.skipEditCommit = false;
	}

	async componentDidMount() {
		document.addEventListener('mousedown', this.onDocumentMouseDown, true);
		this.ensureCatalogs();
		const { isEdit, staffing_level } = this.state;

		if (!isEdit) return;

		try {
			const fullStaffingLevel = await staffingLevelsService.getById(staffing_level.id);
			if (fullStaffingLevel && fullStaffingLevel.needs) {
				this.applyLoadedLevel(fullStaffingLevel);
			}
		} catch (error) {
			console.error('Error fetching staffing level details:', error);
		}
	}

	componentDidUpdate(prevProps) {
		const dayTypesArrived =
			!(prevProps.select_day_types || []).length &&
			(this.props.select_day_types || []).length > 0;
		const timeTypeArrived =
			!(prevProps.default_time_type && prevProps.default_time_type.id) &&
			!!(this.props.default_time_type && this.props.default_time_type.id);
		const timeListArrived =
			!(prevProps.select_time_types || []).length &&
			(this.props.select_time_types || []).length > 0;
		if (!dayTypesArrived && !timeTypeArrived && !timeListArrived) return;
		if (!this.state.selected_functions.length) return;
		if (
			this.state.editorMode === 'shift' &&
			!this.state.selected_shifts.length &&
			!(this.state.staffing_level.needs || []).some((need) => need.time_interval)
		) {
			return;
		}

		this.setState((prev) => ({
			staffing_level: {
				...prev.staffing_level,
				needs: this.needsFor(prev),
			},
		}));
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.onDocumentMouseDown, true);
	}

	ensureCatalogs = () => {
		// La planificación no precarga tipos de día ni el listado completo de
		// ubicaciones. Sin tipos de día, isGridReady deja la matriz oculta.
		if (!(this.props.select_day_types || []).length && this.props.getSelectableDayTypes) {
			this.props.getSelectableDayTypes();
		}
		if (!(this.props.ubications || []).length && this.props.getAllUbications) {
			this.props.getAllUbications();
		}
		if (!(this.props.select_time_types || []).length && this.props.getSelectableTimeTypes) {
			this.props.getSelectableTimeTypes();
		}
		if (!this.props.default_time_type?.id && this.props.getDefaultTimeType) {
			this.props.getDefaultTimeType();
		}
	};

	resolveTimeTypeId = (needs = this.state.staffing_level.needs) => {
		const fromNeed = (needs || [])
			.map((need) => {
				if (!need.time_interval) return null;
				return (
					need.time_interval.time_type_id ||
					(need.time_interval.time_type && need.time_interval.time_type.id) ||
					null
				);
			})
			.find(Boolean);
		if (fromNeed) return Number(fromNeed);

		const { default_time_type, select_time_types = [] } = this.props;
		if (default_time_type && default_time_type.id) return Number(default_time_type.id);
		const work =
			select_time_types.find((type) => type.work_time) || select_time_types[0];
		return work ? Number(work.id) : null;
	};

	needsFor = (prev, patch = {}) => {
		const editorMode = patch.editorMode ?? prev.editorMode;
		const fractions = patch.fractions ?? prev.fractions;
		return syncStaffingNeeds({
			editorMode,
			selectedFunctions: patch.selected_functions ?? prev.selected_functions,
			selectedShifts: patch.selected_shifts ?? prev.selected_shifts,
			fractions,
			selectedUbications: patch.selected_ubications ?? prev.selected_ubications,
			dayTypes: this.props.select_day_types || [],
			hasUbications:
				patch.hasUbications ?? !!prev.staffing_level.has_ubications,
			previousNeeds: patch.previousNeeds ?? prev.staffing_level.needs,
			timeTypeId: this.resolveTimeTypeId(patch.previousNeeds ?? prev.staffing_level.needs),
		});
	};

	extractSelectedItems = (staffing_level) => {
		const selected_functions = [];
		const selected_shifts = [];
		const selected_ubications = [];

		(staffing_level.needs || []).forEach((need) => {
			if (need.function && !selected_functions.some((item) => item.id === need.function.id)) {
				selected_functions.push(need.function);
			}
			if (need.shift && !selected_shifts.some((item) => item.id === need.shift.id)) {
				selected_shifts.push(need.shift);
			}
			if (need.ubication && !selected_ubications.some((item) => item.id === need.ubication.id)) {
				selected_ubications.push(need.ubication);
			}
		});

		return { selected_functions, selected_shifts, selected_ubications };
	};

	applyLoadedLevel = (fullStaffingLevel) => {
		const extracted = this.extractSelectedItems(fullStaffingLevel);
		const hasUbications = !!fullStaffingLevel.has_ubications;
		const setup = inferFractionSetup(fullStaffingLevel.needs || []);
		const savedFractions = fractionsFromNeeds(fullStaffingLevel.needs || []);
		const fractionWindow = fractionWindowFromNeeds(fullStaffingLevel.needs || []);
		const editorMode =
			savedFractions.length > 0 && extracted.selected_shifts.length === 0
				? 'fraction'
				: 'shift';
		const fractions =
			savedFractions.length > 0
				? fractionWindow.fractions
				: buildFractions(setup.start, setup.end, setup.minutes);
		const needs = syncStaffingNeeds({
			editorMode,
			selectedFunctions: extracted.selected_functions,
			selectedShifts: extracted.selected_shifts,
			fractions,
			selectedUbications: extracted.selected_ubications,
			dayTypes: this.props.select_day_types || [],
			hasUbications,
			previousNeeds: fullStaffingLevel.needs || [],
			timeTypeId: this.resolveTimeTypeId(fullStaffingLevel.needs || []),
		});

		this.setState({
			staffing_level: {
				...fullStaffingLevel,
				needs,
				has_ubications: hasUbications,
			},
			editorMode,
			fractionStart: fractionWindow.start,
			fractionEnd: fractionWindow.end,
			fractionMinutes: fractionWindow.minutes,
			fractions,
			...extracted,
			activeFunctionId: extracted.selected_functions[0]
				? extracted.selected_functions[0].id
				: null,
			history: [],
			future: [],
			fractionMemory: rememberFractionNeeds(
				[],
				needs,
				fractions.map((fraction) => fraction.key)
			),
		});
	};

	capture = (state) => {
		const fractions = state.fractions || [];
		const typedIsValid =
			buildFractions(state.fractionStart, state.fractionEnd, state.fractionMinutes).length > 0;
		return {
			needs: state.staffing_level.needs,
			has_ubications: !!state.staffing_level.has_ubications,
			selected_functions: state.selected_functions,
			selected_shifts: state.selected_shifts,
			selected_ubications: state.selected_ubications,
			activeFunctionId: state.activeFunctionId,
			editorMode: state.editorMode,
			fractionStart:
				typedIsValid || !fractions.length ? state.fractionStart : fractions[0].start,
			fractionEnd:
				typedIsValid || !fractions.length
					? state.fractionEnd
					: fractions[fractions.length - 1].end,
			fractionMinutes: state.fractionMinutes,
			fractions,
			fractionMemory: state.fractionMemory || [],
		};
	};

	applySnapshot = (state, snap) => ({
		staffing_level: {
			...state.staffing_level,
			needs: snap.needs,
			has_ubications: snap.has_ubications,
		},
		selected_functions: snap.selected_functions,
		selected_shifts: snap.selected_shifts,
		selected_ubications: snap.selected_ubications,
		activeFunctionId: snap.activeFunctionId,
		editorMode: snap.editorMode,
		fractionStart: snap.fractionStart,
		fractionEnd: snap.fractionEnd,
		fractionMinutes: snap.fractionMinutes,
		fractions: snap.fractions,
		fractionMemory: snap.fractionMemory || [],
		editing: null,
		menu: null,
	});

	undo = () => {
		this.setState((prev) => {
			if (!prev.history.length) return null;
			const snap = prev.history[prev.history.length - 1];
			return {
				...this.applySnapshot(prev, snap),
				history: prev.history.slice(0, -1),
				future: [...prev.future, this.capture(prev)],
			};
		});
	};

	redo = () => {
		this.setState((prev) => {
			if (!prev.future.length) return null;
			const snap = prev.future[prev.future.length - 1];
			return {
				...this.applySnapshot(prev, snap),
				future: prev.future.slice(0, -1),
				history: [...prev.history, this.capture(prev)].slice(-HISTORY_LIMIT),
			};
		});
	};

	checkValidField = (name) => {
		return this.state.submitted && this.state.errors[name] !== undefined && this.state.errors[name] !== '';
	};

	resolveActiveFunction = (state = this.state) => {
		const tabs = orderedByCatalog(this.props.select_functions, state.selected_functions);
		return tabs.find((item) => item.id === state.activeFunctionId) || tabs[0] || null;
	};

	gridRows = (state = this.state) => {
		if (state.editorMode === 'fraction') {
			return buildFractionRows({
				fractions: state.fractions,
				ubications: state.selected_ubications,
				hasUbications: !!state.staffing_level.has_ubications,
			});
		}
		return buildGridRows({
			shifts: state.selected_shifts,
			ubications: state.selected_ubications,
			hasUbications: !!state.staffing_level.has_ubications,
		});
	};

	handleSubmit = async (event) => {
		event.preventDefault();
		this.setState({ isLoading: true });

		const { staffing_level, isEdit, selected_ubications } = this.state;
		const hasUbications = !!staffing_level.has_ubications && selected_ubications.length > 0;
		const needs = this.needsFor(this.state);
		const staffing_level_temp = {
			name: staffing_level.name,
			description: staffing_level.description,
			needs: toSubmitPayload(needs),
			has_ubications: hasUbications,
		};
		const hasUntypedFraction = needs.some(
			(need) =>
				normalizeCounter(need.counter) > 0 &&
				need.time_interval &&
				!(need.shift && need.shift.id) &&
				!(
					need.time_interval.time_type_id ||
					(need.time_interval.time_type && need.time_interval.time_type.id)
				)
		);
		if (hasUntypedFraction) {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: { needs: this.props.t('staffingLevels.form.missingTimeType') },
			});
			return;
		}

		try {
			const response = isEdit
				? await staffingLevelsService.update({ ...staffing_level_temp, id: staffing_level.id })
				: await staffingLevelsService.add(staffing_level_temp);

			if (response.ok) {
				this.setState({
					isLoading: false,
					errors: {},
				});
				toastr.success(this.props.t('common.success'), this.props.t('common.changesSaved'));
				(this.props.getStaffingLevels || this.props.getAllStaffingLevels)();
				this.props.handleClose();
				return;
			}

			const errors = errorFormating(response);
			this.setState({
				isLoading: false,
				submitted: true,
				errors,
			});
			toastr.error(
				this.props.t('common.error'),
				errors.general || this.props.t('common.errorSaving')
			);
		} catch (error) {
			this.setState({
				isLoading: false,
				submitted: true,
			});
			toastr.error(this.props.t('common.error'), this.props.t('common.errorSaving'));
		}
	};

	handleChange = (event) => {
		const { staffing_level } = this.state;
		this.setState({
			staffing_level: {
				...staffing_level,
				[event.target.id]: event.target.value,
			},
		});
	};

	handleSwitch = (event) => {
		const checked = event.target.checked;
		this.setState((prev) => ({
			history: [...prev.history, this.capture(prev)].slice(-HISTORY_LIMIT),
			future: [],
			editing: null,
			menu: null,
			staffing_level: {
				...prev.staffing_level,
				has_ubications: checked,
				needs: this.needsFor(prev, { hasUbications: checked }),
			},
		}));
	};

	toggleItem = (kind, item) => {
		this.setState((prev) => {
			const listKey =
				kind === 'functions'
					? 'selected_functions'
					: kind === 'shifts'
						? 'selected_shifts'
						: 'selected_ubications';
			const current = prev[listKey];
			const exists = current.some((entry) => entry.id === item.id);
			const nextList = exists
				? current.filter((entry) => entry.id !== item.id)
				: [...current, item];
			const selected_functions = kind === 'functions' ? nextList : prev.selected_functions;
			const selected_shifts = kind === 'shifts' ? nextList : prev.selected_shifts;
			const selected_ubications = kind === 'ubications' ? nextList : prev.selected_ubications;
			let activeFunctionId = prev.activeFunctionId;

			if (kind === 'functions') {
				if (!exists && !nextList.some((entry) => entry.id === activeFunctionId)) {
					activeFunctionId = item.id;
				} else if (!nextList.some((entry) => entry.id === activeFunctionId)) {
					activeFunctionId = nextList[0] ? nextList[0].id : null;
				}
			}

			return {
				history: [...prev.history, this.capture(prev)].slice(-HISTORY_LIMIT),
				future: [],
				editing: null,
				menu: null,
				selected_functions,
				selected_shifts,
				selected_ubications,
				activeFunctionId,
				staffing_level: {
					...prev.staffing_level,
					needs: this.needsFor(prev, {
						selected_functions,
						selected_shifts,
						selected_ubications,
					}),
				},
			};
		});
	};

	onFormKeyDown = (event) => {
		const key = event.key.toLowerCase();
		const meta = event.metaKey || event.ctrlKey;
		if (!meta || (key !== 'z' && key !== 'y')) return;
		const tag = event.target.tagName;
		if (tag === 'INPUT' || tag === 'TEXTAREA') return;
		event.preventDefault();
		if (key === 'y' || event.shiftKey) this.redo();
		else this.undo();
	};

	onDocumentMouseDown = (event) => {
		const { menu, openCatalog, editing } = this.state;
		if (!menu && !openCatalog && !editing) return;
		const target = event.target;
		const closest = target.closest ? (selector) => target.closest(selector) : () => null;
		const patch = {};
		if (menu && !closest('[data-sl-menu]') && !closest('[data-sl-menu-trigger]')) {
			patch.menu = null;
		}
		if (openCatalog && !closest('[data-sl-catalog]')) patch.openCatalog = null;
		if (editing && !closest('[data-sl-stepper]')) {
			this.skipEditCommit = true;
			this.commitEdit();
		}
		if (Object.keys(patch).length) this.setState(patch);
	};

	toggleCatalog = (kind) => {
		this.setState((prev) => ({
			openCatalog: prev.openCatalog === kind ? null : kind,
			catalogQuery: '',
			menu: null,
		}));
	};

	setCatalogQuery = (value) => {
		this.setState({ catalogQuery: value });
	};

	clearCatalog = (kind) => {
		this.setState((prev) => {
			const selected_functions = kind === 'functions' ? [] : prev.selected_functions;
			const selected_shifts = kind === 'shifts' ? [] : prev.selected_shifts;
			const selected_ubications = kind === 'ubications' ? [] : prev.selected_ubications;
			return {
				history: [...prev.history, this.capture(prev)].slice(-HISTORY_LIMIT),
				future: [],
				editing: null,
				menu: null,
				selected_functions,
				selected_shifts,
				selected_ubications,
				activeFunctionId: kind === 'functions' ? null : prev.activeFunctionId,
				staffing_level: {
					...prev.staffing_level,
					needs: this.needsFor(prev, {
						selected_functions,
						selected_shifts,
						selected_ubications,
					}),
				},
			};
		});
	};

	toggleLocation = (ubicationId) => {
		this.setState((prev) => ({
			collapsedLocations: {
				...prev.collapsedLocations,
				[ubicationId]: !prev.collapsedLocations[ubicationId],
			},
			menu: null,
		}));
	};

	stepCell = (delta) => {
		this.setState((prev) => {
			if (!prev.editing) return null;
			const { functionId, shiftId, fractionKey, dayTypeId, ubicationId, draft } = prev.editing;
			const current = readSlotCounter(prev.staffing_level.needs, prev.editing);
			const value = Math.min(999, Math.max(0, normalizeCounter(draft) + delta));
			const nextDraft = value > 0 ? String(value) : '';
			if (value === current && draft === nextDraft) return null;
			const needsChanged = value !== current;
			return {
				editing: {
					...prev.editing,
					counter: value,
					draft: nextDraft,
				},
				menu: null,
				...(needsChanged
					? {
							history: [...prev.history, this.capture(prev)].slice(-HISTORY_LIMIT),
							future: [],
							staffing_level: {
								...prev.staffing_level,
								needs: applySlotUpdates(prev.staffing_level.needs, [
									{ functionId, shiftId, fractionKey, dayTypeId, ubicationId, value },
								]),
							},
						}
					: {}),
			};
		});
	};

	compactRange = (range) => {
		if (!range) return '';
		const parts = range.split('-').map((part) => part.trim());
		if (parts.length < 2) return range;
		const short = (value) => value.replace(/:00$/, '');
		return `${short(parts[0])}-${short(parts[1])}h`;
	};

	shiftChipLabel = (shift) => {
		const range = this.compactRange(this.shiftRangeLabel(shift));
		return range ? `${shift.name} ${range}` : shift.name;
	};

	chipStyle = (color) => {
		if (!color) return undefined;
		return { backgroundColor: color, color: '#0d0a2c' };
	};

	armDigit = (value) => {
		this.setState((prev) => {
			const armed = prev.brush === value && prev.customBrush === '';
			return {
				brush: armed ? null : value,
				customBrush: '',
				editing: null,
				menu: null,
			};
		});
	};

	onCustomBrush = (event) => {
		const raw = event.target.value.replace(/[^\d]/g, '').slice(0, 3);
		this.setState({
			customBrush: raw,
			brush: raw === '' ? null : normalizeCounter(raw),
			editing: null,
			menu: null,
		});
	};

	onGridPointerDown = (event) => {
		if (event.button !== 0 || this.state.brush == null) return;
		const cell = event.target.closest && event.target.closest('[data-sl-cell]');
		if (!cell) return;
		event.preventDefault();
		this.painting = true;
		this.paintHistoryRecorded = false;
		this.paintValue = this.state.brush;
		this.paintAnchor = cell;
		this.paintBaseNeeds = this.state.staffing_level.needs;
		if (event.currentTarget.setPointerCapture) {
			event.currentTarget.setPointerCapture(event.pointerId);
		}
		this.applyPaint(this.cellsInRectangle(cell, cell));
	};

	onGridPointerMove = (event) => {
		if (!this.painting || !this.paintAnchor) return;
		const el = document.elementFromPoint(event.clientX, event.clientY);
		const cell = el && el.closest ? el.closest('[data-sl-cell]') : null;
		if (!cell) return;
		if (cell.dataset.functionId !== this.paintAnchor.dataset.functionId) return;
		if (cell.dataset.ubicationId !== this.paintAnchor.dataset.ubicationId) return;
		this.applyPaint(this.cellsInRectangle(this.paintAnchor, cell));
	};

	onGridPointerUp = () => {
		this.painting = false;
		this.paintAnchor = null;
	};

	cellsInRectangle = (anchor, current) => {
		const cells = Array.from(document.querySelectorAll('[data-sl-cell]')).filter(
			(cell) =>
				cell.dataset.functionId === anchor.dataset.functionId &&
				cell.dataset.ubicationId === anchor.dataset.ubicationId
		);
		const rowIndex = new Map();
		const colIndex = new Map();
		const rowIdOf = (cell) => cell.dataset.fractionKey || cell.dataset.shiftId;
		cells.forEach((cell) => {
			const rowId = rowIdOf(cell);
			if (!rowIndex.has(rowId)) rowIndex.set(rowId, rowIndex.size);
			if (!colIndex.has(cell.dataset.dayId)) colIndex.set(cell.dataset.dayId, colIndex.size);
		});
		const minRow = Math.min(rowIndex.get(rowIdOf(anchor)), rowIndex.get(rowIdOf(current)));
		const maxRow = Math.max(rowIndex.get(rowIdOf(anchor)), rowIndex.get(rowIdOf(current)));
		const minCol = Math.min(colIndex.get(anchor.dataset.dayId), colIndex.get(current.dataset.dayId));
		const maxCol = Math.max(colIndex.get(anchor.dataset.dayId), colIndex.get(current.dataset.dayId));

		return cells
			.filter((cell) => {
				const row = rowIndex.get(rowIdOf(cell));
				const col = colIndex.get(cell.dataset.dayId);
				return row >= minRow && row <= maxRow && col >= minCol && col <= maxCol;
			})
			.map((cell) => ({
				functionId: Number(cell.dataset.functionId),
				shiftId: cell.dataset.shiftId === '' ? null : Number(cell.dataset.shiftId),
				fractionKey: cell.dataset.fractionKey || null,
				dayTypeId: Number(cell.dataset.dayId),
				ubicationId: cell.dataset.ubicationId === '' ? null : Number(cell.dataset.ubicationId),
			}));
	};

	applyPaint = (cells) => {
		if (!cells.length) return;
		const updates = cells.map((cell) => ({ ...cell, value: this.paintValue }));
		this.setState((prev) => {
			const base = this.paintBaseNeeds || prev.staffing_level.needs;
			const needs = applySlotUpdates(base, updates);
			const unchanged = needs.every((need, index) => need === base[index]);
			if (unchanged) {
				if (prev.staffing_level.needs === base) return null;
				return {
					menu: null,
					editing: null,
					staffing_level: { ...prev.staffing_level, needs: base },
				};
			}
			const record = !this.paintHistoryRecorded;
			this.paintHistoryRecorded = true;
			return {
				menu: null,
				editing: null,
				history: record
					? [...prev.history, this.capture(prev)].slice(-HISTORY_LIMIT)
					: prev.history,
				future: record ? [] : prev.future,
				staffing_level: { ...prev.staffing_level, needs },
			};
		});
	};

	setEditInput = (node) => {
		this.editInput = node;
	};

	openEdit = (cell) => {
		if (this.state.brush != null) return;
		if (this.state.editing && this.state.editing.key === cell.key) return;
		this.setState(
			{
				editing: {
					...cell,
					draft: cell.counter > 0 ? String(cell.counter) : '',
				},
				menu: null,
			},
			() => {
				const input = this.editInput;
				if (!input || document.activeElement !== input) return;
				input.select();
			}
		);
	};

	onEditDraft = (event) => {
		const draft = event.target.value.replace(/[^\d]/g, '').slice(0, 3);
		this.setState((prev) => (prev.editing ? { editing: { ...prev.editing, draft } } : null));
	};

	commitEdit = () => {
		const input = this.editInput;
		this.setState((prev) => {
			if (!prev.editing) return null;
			const { functionId, shiftId, fractionKey, dayTypeId, ubicationId, draft } = prev.editing;
			const value = normalizeCounter(draft);
			const current = readSlotCounter(prev.staffing_level.needs, prev.editing);
			if (current === value) return { editing: null };
			return {
				editing: null,
				history: [...prev.history, this.capture(prev)].slice(-HISTORY_LIMIT),
				future: [],
				staffing_level: {
					...prev.staffing_level,
					needs: applySlotUpdates(prev.staffing_level.needs, [
						{ functionId, shiftId, fractionKey, dayTypeId, ubicationId, value },
					]),
				},
			};
		}, () => {
			if (input && document.activeElement === input) {
				this.skipEditCommit = true;
				input.blur();
			}
		});
	};

	onEditBlur = (event) => {
		if (this.skipEditCommit) {
			this.skipEditCommit = false;
			return;
		}
		const next = event.relatedTarget;
		if (next && next.closest && next.closest('[data-sl-stepper]')) return;
		this.commitEdit();
	};

	onEditKeyDown = (event) => {
		if (event.key === 'Enter') {
			event.preventDefault();
			this.commitEdit();
		}
		if (event.key === 'Escape') {
			event.preventDefault();
			event.stopPropagation();
			const input = event.target;
			this.skipEditCommit = true;
			this.setState({ editing: null }, () => {
				if (input && document.activeElement === input) input.blur();
			});
		}
	};

	openMenu = (event, spec) => {
		event.preventDefault();
		event.stopPropagation();
		const rect = event.currentTarget.getBoundingClientRect();
		const left = Math.max(8, Math.min(rect.left, window.innerWidth - 188));
		this.setState((prev) => {
			if (prev.menu && prev.menu.id === spec.id) return { menu: null };
			return {
				menu: {
					...spec,
					top: rect.bottom + 6,
					left,
				},
			};
		});
	};

	copyColumn = (dayTypeId) => {
		const active = this.resolveActiveFunction();
		if (!active) return;
		this.setState((prev) => ({
			clipboard: columnClipboard(prev.staffing_level.needs, {
				functionId: active.id,
				dayTypeId,
				rows: this.gridRows(prev),
			}),
			menu: null,
		}));
	};

	pasteColumn = (dayTypeId) => {
		const active = this.resolveActiveFunction();
		if (!active) return;
		this.setState((prev) => {
			if (!prev.clipboard || prev.clipboard.kind !== 'column') return { menu: null };
			return {
				history: [...prev.history, this.capture(prev)].slice(-HISTORY_LIMIT),
				future: [],
				menu: null,
				editing: null,
				staffing_level: {
					...prev.staffing_level,
					needs: applyColumnClipboard(prev.staffing_level.needs, {
						functionId: active.id,
						dayTypeId,
						clipboard: prev.clipboard,
					}),
				},
			};
		});
	};

	copyRow = (shiftId, ubicationId, fractionKey) => {
		const active = this.resolveActiveFunction();
		if (!active) return;
		this.setState((prev) => ({
			clipboard: rowClipboard(prev.staffing_level.needs, {
				functionId: active.id,
				shiftId,
				fractionKey,
				ubicationId,
				dayTypes: this.props.select_day_types || [],
			}),
			menu: null,
		}));
	};

	pasteRow = (shiftId, ubicationId, fractionKey) => {
		const active = this.resolveActiveFunction();
		if (!active) return;
		this.setState((prev) => {
			if (!prev.clipboard || prev.clipboard.kind !== 'row') return { menu: null };
			return {
				history: [...prev.history, this.capture(prev)].slice(-HISTORY_LIMIT),
				future: [],
				menu: null,
				editing: null,
				staffing_level: {
					...prev.staffing_level,
					needs: applyRowClipboard(prev.staffing_level.needs, {
						functionId: active.id,
						shiftId,
						fractionKey,
						ubicationId,
						clipboard: prev.clipboard,
					}),
				},
			};
		});
	};

	editorHasContent = (state = this.state) => {
		const needs = (state.staffing_level && state.staffing_level.needs) || [];
		if (needs.some((need) => normalizeCounter(need.counter) > 0)) return true;
		return state.editorMode === 'shift' && (state.selected_shifts || []).length > 0;
	};

	requestEditorMode = (editorMode) => {
		if (this.state.editorMode === editorMode) {
			if (this.state.pendingEditorMode) this.setState({ pendingEditorMode: null });
			return;
		}
		if (!this.editorHasContent()) {
			this.setEditorMode(editorMode);
			return;
		}
		this.setState({ pendingEditorMode: editorMode });
	};

	cancelEditorMode = () => {
		this.setState({ pendingEditorMode: null });
	};

	confirmEditorMode = () => {
		const editorMode = this.state.pendingEditorMode;
		if (!editorMode) return;
		this.setEditorMode(editorMode);
	};

	setEditorMode = (editorMode) => {
		this.setState((prev) => {
			if (prev.editorMode === editorMode) return null;
			const fractions =
				editorMode === 'fraction' && !(prev.fractions || []).length
					? buildFractions(prev.fractionStart, prev.fractionEnd, prev.fractionMinutes)
					: prev.fractions;
			return {
				history: [...prev.history, this.capture(prev)].slice(-HISTORY_LIMIT),
				future: [],
				editing: null,
				menu: null,
				pendingEditorMode: null,
				editorMode,
				fractions,
				selected_shifts: [],
				fractionMemory: [],
				staffing_level: {
					...prev.staffing_level,
					needs: this.needsFor(prev, {
						editorMode,
						fractions,
						selected_shifts: [],
						previousNeeds: [],
					}),
				},
			};
		});
	};

	onFractionClockChange = (field, event) => {
		const value = event.target.value;
		if (!/^\d{2}:\d{2}$/.test(value)) return;
		const start = field === 'fractionStart' ? value : this.state.fractionStart;
		const end = field === 'fractionEnd' ? value : this.state.fractionEnd;
		if (!buildFractions(start, end, this.state.fractionMinutes).length) return;
		if (value !== this.state[field]) this.setFractionWindow({ [field]: value });
	};

	onFractionClockBlur = (field, event) => {
		const typed = event && event.target ? event.target.value : '';
		if (typed === this.state[field]) return;
		this.setState((prev) => ({
			[`${field}Epoch`]: (prev[`${field}Epoch`] || 0) + 1,
		}));
	};

	setFractionWindow = (patch) => {
		this.setState((prev) => {
			const fractionStart = patch.fractionStart ?? prev.fractionStart;
			const fractionEnd = patch.fractionEnd ?? prev.fractionEnd;
			const fractionMinutes = patch.fractionMinutes ?? prev.fractionMinutes;
			const nextFractions = buildFractions(fractionStart, fractionEnd, fractionMinutes);
			const fractionMemory = rememberFractionNeeds(
				prev.fractionMemory,
				prev.staffing_level.needs,
				(prev.fractions || []).map((fraction) => fraction.key)
			);

			// 09:00 → "1" llega como 01:00 y deja el fin antes del inicio.
			// Esa hora a medias no debe vaciar la matriz.
			if (!nextFractions.length) {
				return {
					fractionStart,
					fractionEnd,
					fractionMinutes,
					fractionMemory,
					editing: null,
					menu: null,
				};
			}

			const previousFractions = prev.fractions || [];
			const sameGrid =
				fractionMinutes === prev.fractionMinutes &&
				nextFractions.length === previousFractions.length &&
				nextFractions.every((fraction, index) => fraction.key === previousFractions[index].key);

			if (sameGrid) {
				return {
					fractionStart,
					fractionEnd,
					fractionMinutes,
					fractionMemory,
					editing: null,
					menu: null,
				};
			}

			const shiftNeeds = (prev.staffing_level.needs || []).filter(
				(need) => need.shift && need.shift.id
			);

			return {
				history: [...prev.history, this.capture({ ...prev, fractionMemory })].slice(-HISTORY_LIMIT),
				future: [],
				editing: null,
				menu: null,
				fractionStart,
				fractionEnd,
				fractionMinutes,
				fractions: nextFractions,
				fractionMemory,
				staffing_level: {
					...prev.staffing_level,
					needs: this.needsFor(prev, {
						fractions: nextFractions,
						editorMode: 'fraction',
						previousNeeds: [...shiftNeeds, ...fractionMemory],
					}),
				},
			};
		});
	};

	shiftRangeLabel = (shift) => {
		const label = getFirstLastInterval(shift.time_intervals, true);
		if (typeof label !== 'string') return '';
		return label.replace(/^🕐\s*/, '');
	};

	renderCatalog = (kind, label, catalog) => {
		const { openCatalog, catalogQuery } = this.state;
		const selected =
			kind === 'functions'
				? this.state.selected_functions
				: kind === 'shifts'
					? this.state.selected_shifts
					: this.state.selected_ubications;
		const t = this.props.t;
		const searchKey =
			kind === 'functions' ? 'searchFunction' : kind === 'shifts' ? 'searchShift' : 'searchUbication';
		const visible = filterCatalog(
			catalog,
			selected,
			openCatalog === kind ? catalogQuery : '',
			(item) => (kind === 'shifts' ? this.shiftChipLabel(item) : item.name)
		);

		return (
			<StaffingCatalogSelect
				label={label}
				items={visible}
				selected={selected}
				open={openCatalog === kind}
				query={openCatalog === kind ? catalogQuery : ''}
				catalogEmpty={catalog.length === 0}
				onToggleOpen={() => this.toggleCatalog(kind)}
				onQuery={this.setCatalogQuery}
				onToggleItem={(item) => this.toggleCatalogItem(kind, item)}
				onClear={() => this.clearCatalog(kind)}
				chipOf={(item) => this.catalogChip(kind, item)}
				searchPlaceholder={t(`staffingLevels.form.${searchKey}`)}
				emptyLabel={t('staffingLevels.form.emptyCatalog')}
				noMatchesLabel={t('staffingLevels.form.noMatches')}
				selectedLabel={t('staffingLevels.form.selectedCount', { count: selected.length })}
				clearLabel={t('staffingLevels.form.clearSelection')}
			/>
		);
	};

	catalogChip = (kind, item) => {
		const t = this.props.t;
		if (kind === 'shifts') {
			return {
				label: this.shiftChipLabel(item),
				style: this.chipStyle(item.background_color || item.color),
				removeLabel: t('common.delete'),
			};
		}
		if (kind === 'ubications') {
			return {
				label: item.name,
				style: this.chipStyle(item.background_color || item.border_color),
				removeLabel: t('common.delete'),
			};
		}
		return {
			label: item.name,
			style: undefined,
			removeLabel: t('common.delete'),
		};
	};

	toggleCatalogItem = (kind, item) => {
		this.toggleItem(kind, item);
	};

	renderCell = (active, row, dayType, ubication, peak) => {
		const { brush, editing, staffing_level } = this.state;
		const ubicationId = ubication ? ubication.id : null;
		const fractionKey = row.fraction ? row.fraction.key : null;
		const shiftId = row.shift ? row.shift.id : null;
		const slotLabel = row.fraction
			? `${row.fraction.start}–${row.fraction.end}`
			: row.shift.name;
		const counter = readSlotCounter(staffing_level.needs, {
			functionId: active.id,
			shiftId,
			fractionKey,
			dayTypeId: dayType.id,
			ubicationId,
		});
		const key = fractionKey
			? `${active.id}:${fractionKey}:${dayType.id}:${ubicationId == null ? '' : ubicationId}`
			: cellKey(active.id, shiftId, dayType.id, ubicationId);
		const isEditing = editing && editing.key === key;
		const fillStyle = cellFillStyle(counter, peak);
		const label = ubication
			? this.props.t('staffingLevels.form.cellLabelLocation', {
				day: dayType.name,
				shift: slotLabel,
				ubication: ubication.name,
				value: counter > 0 ? counter : '-',
			})
			: this.props.t('staffingLevels.form.cellLabel', {
				day: dayType.name,
				shift: slotLabel,
				value: counter > 0 ? counter : '-',
			});

		const cell = {
			key,
			functionId: active.id,
			shiftId,
			fractionKey,
			dayTypeId: dayType.id,
			ubicationId,
			counter,
		};

		if (brush != null) {
			return (
				<td key={dayType.id}>
					<button
						type="button"
						className={`sl-cell is-paintable${fillStyle ? ' is-filled' : ''}`}
						style={fillStyle}
						data-sl-cell="true"
						data-function-id={active.id}
						data-shift-id={shiftId == null ? '' : shiftId}
						data-fraction-key={fractionKey || ''}
						data-day-id={dayType.id}
						data-ubication-id={ubicationId == null ? '' : ubicationId}
						aria-label={label}
						onClick={() => this.openEdit(cell)}
					>
						{counter > 0 ? counter : '-'}
					</button>
				</td>
			);
		}

		return (
			<td key={dayType.id}>
				<div
					className={`sl-cell-editor${isEditing ? ' is-editing' : ''}${counter > 0 ? ' is-filled' : ''}`}
					style={fillStyle || undefined}
					data-sl-stepper={isEditing ? 'true' : undefined}
				>
					<input
						ref={isEditing ? this.setEditInput : undefined}
						type="text"
						inputMode="numeric"
						size={1}
						autoComplete="off"
						spellCheck={false}
						className="sl-stepper-value"
						value={isEditing ? editing.draft : counter > 0 ? String(counter) : ''}
						placeholder="-"
						aria-label={label}
						onFocus={() => this.openEdit(cell)}
						onChange={this.onEditDraft}
						onBlur={this.onEditBlur}
						onKeyDown={this.onEditKeyDown}
					/>
					{isEditing && (
						<span className="sl-stepper-arrows">
							<button
								type="button"
								aria-label={label}
								onMouseDown={(event) => event.preventDefault()}
								onClick={() => this.stepCell(1)}
							>
								<FiChevronUp aria-hidden="true" />
							</button>
							<button
								type="button"
								onMouseDown={(event) => event.preventDefault()}
								onClick={() => this.stepCell(-1)}
							>
								<FiChevronDown aria-hidden="true" />
							</button>
						</span>
					)}
				</div>
			</td>
		);
	};

	renderGridTable = (active, dayTypes, shiftList, ubication, peak) => {
		const { menu } = this.state;
		const t = this.props.t;
		const columnKey = ubication ? ubication.id : 'x';

		return (
			<table className="sl-grid">
				<thead>
					<tr>
						<th className="sl-corner">
							<span className="sl-head-pill">
								{t(
									this.state.editorMode === 'fraction'
										? 'staffingLevels.form.fractionColumn'
										: 'staffingLevels.form.shiftColumn'
								)}
							</span>
						</th>
						{dayTypes.map((dayType) => {
							const menuId = `col-${columnKey}-${dayType.id}`;
							return (
								<th key={dayType.id}>
									<button
										type="button"
										className={`sl-head-pill${menu && menu.id === menuId ? ' is-open' : ''}`}
										data-sl-menu-trigger="true"
										onClick={(event) =>
											this.openMenu(event, { id: menuId, type: 'column', dayTypeId: dayType.id })
										}
										onContextMenu={(event) =>
											this.openMenu(event, { id: menuId, type: 'column', dayTypeId: dayType.id })
										}
									>
										{dayType.name}
									</button>
								</th>
							);
						})}
					</tr>
				</thead>
				<tbody>
					{shiftList.map((row) => {
						const ubicationId = row.ubication ? row.ubication.id : null;
						const rowToken = row.fraction ? row.fraction.key : row.shift.id;
						const menuId = `row-${rowToken}-${ubicationId == null ? 'x' : ubicationId}`;
						const chipLabel = row.fraction
							? `${row.fraction.start}–${row.fraction.end}`
							: this.shiftChipLabel(row.shift);
						return (
							<tr key={menuId}>
								<th className="sl-shift-head">
									<button
										type="button"
										className={`sl-shift-chip${menu && menu.id === menuId ? ' is-open' : ''}`}
										style={this.chipStyle(
											row.shift
												? row.shift.background_color || row.shift.color || '#ebe9ff'
												: '#ebe9ff'
										)}
										data-sl-menu-trigger="true"
										onClick={(event) =>
											this.openMenu(event, {
												id: menuId,
												type: 'row',
												shiftId: row.shift ? row.shift.id : null,
												fractionKey: row.fraction ? row.fraction.key : null,
												ubicationId,
											})
										}
										onContextMenu={(event) =>
											this.openMenu(event, {
												id: menuId,
												type: 'row',
												shiftId: row.shift ? row.shift.id : null,
												fractionKey: row.fraction ? row.fraction.key : null,
												ubicationId,
											})
										}
									>
										{chipLabel}
									</button>
								</th>
								{dayTypes.map((dayType) =>
									this.renderCell(active, row, dayType, row.ubication, peak)
								)}
							</tr>
						);
					})}
				</tbody>
			</table>
		);
	};

	renderGrid = (active, dayTypes) => {
		const { staffing_level, collapsedLocations } = this.state;
		const peak = gridPeak(staffing_level.needs, active.id);
		const rows = this.gridRows();
		const dataRows = rows.filter((row) => row.kind === 'shift' || row.kind === 'fraction');
		const t = this.props.t;

		if (!dataRows.length) return null;

		const groups = [];
		if (!staffing_level.has_ubications) {
			groups.push({ ubication: null, shifts: dataRows });
		} else {
			let current = null;
			rows.forEach((row) => {
				if (row.kind === 'ubication') {
					current = { ubication: row.ubication, shifts: [] };
					groups.push(current);
					return;
				}
				if (current) current.shifts.push(row);
			});
		}

		return (
			<div
				className={`sl-grid-scroll${this.state.brush != null ? ' is-painting' : ''}`}
				onPointerDown={this.onGridPointerDown}
				onPointerMove={this.onGridPointerMove}
				onPointerUp={this.onGridPointerUp}
				onPointerCancel={this.onGridPointerUp}
			>
				{groups.map((group) => {
					const ubication = group.ubication;
					if (!ubication) {
						return (
							<div key="plain" className="sl-grid-block">
								{this.renderGridTable(active, dayTypes, group.shifts, null, peak)}
							</div>
						);
					}
					const collapsed = !!collapsedLocations[ubication.id];
					const total = ubicationTotal(staffing_level.needs, active.id, ubication.id);
					return (
						<section key={ubication.id} className="sl-grid-block">
							<button
								type="button"
								className="sl-location"
								aria-expanded={!collapsed}
								onClick={() => this.toggleLocation(ubication.id)}
							>
								{collapsed ? <FiChevronRight aria-hidden="true" /> : <FiChevronDown aria-hidden="true" />}
								<span>{ubication.name}</span>
								<span className="sl-tab-count">{t('staffingLevels.form.peopleShort', { count: total })}</span>
							</button>
							{!collapsed && this.renderGridTable(active, dayTypes, group.shifts, ubication, peak)}
						</section>
					);
				})}
			</div>
		);
	};

	renderMenu = () => {
		const { menu, clipboard } = this.state;
		if (!menu) return null;
		const t = this.props.t;
		const isColumn = menu.type === 'column';
		const canPaste = clipboard && clipboard.kind === (isColumn ? 'column' : 'row');

		return createPortal(
			<div className="sl-menu" style={{ top: menu.top, left: menu.left }} data-sl-menu="true" role="menu">
				<button
					type="button"
					role="menuitem"
					onClick={() =>
						isColumn
							? this.copyColumn(menu.dayTypeId)
							: this.copyRow(menu.shiftId, menu.ubicationId, menu.fractionKey)
					}
				>
					{isColumn ? t('staffingLevels.form.copyColumn') : t('staffingLevels.form.copyRow')}
				</button>
				<button
					type="button"
					role="menuitem"
					disabled={!canPaste}
					onClick={() =>
						isColumn
							? this.pasteColumn(menu.dayTypeId)
							: this.pasteRow(menu.shiftId, menu.ubicationId, menu.fractionKey)
					}
				>
					{isColumn ? t('staffingLevels.form.pasteColumn') : t('staffingLevels.form.pasteRow')}
				</button>
			</div>,
			document.body
		);
	};

	renderAssign = () => {
		const { brush, customBrush } = this.state;
		const t = this.props.t;

		return (
			<>
				<div className="sl-assign">
					<span className="sl-assign-label">{t('staffingLevels.form.assign')}:</span>
					<div className="sl-assign-digits">
						{ASSIGN_DIGITS.map((digit) => (
							<button
								key={digit}
								type="button"
								className={`sl-digit${brush === digit && customBrush === '' ? ' is-armed' : ''}`}
								onClick={() => this.armDigit(digit)}
							>
								{digit}
							</button>
						))}
						<input
							type="text"
							inputMode="numeric"
							className={`sl-digit sl-digit-custom${customBrush !== '' ? ' is-armed' : ''}`}
							value={customBrush}
							placeholder={t('staffingLevels.form.customValue')}
							aria-label={t('staffingLevels.form.customValue')}
							onChange={this.onCustomBrush}
							onKeyDown={(event) => {
								if (event.key === 'Enter') event.preventDefault();
							}}
						/>
					</div>
				</div>
				{brush != null && (
					<div className="sl-assign-banner">
						<FiGrid aria-hidden="true" />
						<span>{t('staffingLevels.form.assignMode', { value: brush })}</span>
					</div>
				)}
			</>
		);
	};

	render() {
		const {
			staffing_level,
			selected_functions,
			selected_shifts,
			selected_ubications,
			activeFunctionId,
			editorMode,
			fractionStart,
			fractionEnd,
			fractionStartEpoch,
			fractionEndEpoch,
			fractionMinutes,
			fractions,
			history,
			future,
			errors,
			pendingEditorMode,
		} = this.state;
		const {
			select_functions = [],
			attendance_shifts = [],
			ubications = [],
			select_ubications = [],
			select_day_types = [],
		} = this.props;
		const locationCatalog = ubications.length ? ubications : select_ubications;
		const t = this.props.t;
		const hasUbications = !!staffing_level.has_ubications;
		const tabs = orderedByCatalog(select_functions, selected_functions);
		const active = tabs.find((item) => item.id === activeFunctionId) || tabs[0] || null;
		const fractionMode = editorMode === 'fraction';
		const fractionTabLabel = t(
			fractionMinutes === 15
				? 'staffingLevels.form.byFraction15'
				: fractionMinutes === 30
					? 'staffingLevels.form.byFraction30'
					: 'staffingLevels.form.byFractionHour'
		);
		const ready = fractionMode
			? isFractionGridReady({
				selectedFunctions: selected_functions,
				fractions,
				selectedUbications: selected_ubications,
				hasUbications,
				dayTypes: select_day_types,
			})
			: isGridReady({
				selectedFunctions: selected_functions,
				selectedShifts: selected_shifts,
				selectedUbications: selected_ubications,
				hasUbications,
				dayTypes: select_day_types,
			});
		return (
			<>
			<form onSubmit={this.handleSubmit} onKeyDown={this.onFormKeyDown}>
				<div className="modal-body staffing-level-edit staffing-level-grid">
					<Row>
						<Col sm={6}>
							<FormGroup className="form-group" controlId="name">
								<FormLabel>
									{t('common.name')} <span className="label-required">*</span>
								</FormLabel>
								<FormControl
									type="text"
									value={staffing_level.name || ''}
									onChange={this.handleChange}
									placeholder={t('staffingLevels.form.namePlaceholder')}
									isInvalid={this.checkValidField('name')}
								/>
								<FormControl.Feedback type="invalid">{errors.name}</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={6}>
							<FormGroup className="form-group" controlId="description">
								<FormLabel>{t('common.description')}</FormLabel>
								<FormControl
									type="text"
									value={staffing_level.description || ''}
									onChange={this.handleChange}
									placeholder={t('staffingLevels.form.descriptionPlaceholder')}
									isInvalid={this.checkValidField('description')}
								/>
								<FormControl.Feedback type="invalid">{errors.description}</FormControl.Feedback>
							</FormGroup>
						</Col>
					</Row>

					<div className="sl-modebar">
						<div className="sl-modes" role="tablist">
							<button
								type="button"
								className={`sl-mode${fractionMode ? '' : ' is-active'}`}
								role="tab"
								aria-selected={!fractionMode}
								onClick={() => this.requestEditorMode('shift')}
							>
								{t('staffingLevels.form.byShift')}
							</button>
							<button
								type="button"
								className={`sl-mode${fractionMode ? ' is-active' : ''}`}
								role="tab"
								aria-selected={fractionMode}
								onClick={() => this.requestEditorMode('fraction')}
							>
								{fractionTabLabel}
								<span className="sl-mode-new">{t('staffingLevels.form.newBadge')}</span>
							</button>
						</div>
						<div className="sl-history">
							<button
								type="button"
								className="sl-history-btn"
								onClick={this.undo}
								disabled={!history.length}
								aria-label={t('staffingLevels.form.undo')}
								title={t('staffingLevels.form.undo')}
							>
								<FiCornerUpLeft />
							</button>
							<button
								type="button"
								className="sl-history-btn"
								onClick={this.redo}
								disabled={!future.length}
								aria-label={t('staffingLevels.form.redo')}
								title={t('staffingLevels.form.redo')}
							>
								<FiCornerUpRight />
							</button>
						</div>
					</div>

					<div className="sl-switch-row">
						<Switch
							controlId="has_ubications"
							isOn={hasUbications}
							handleToggle={this.handleSwitch}
						/>
						<label htmlFor="has_ubications">{t('staffingLevels.form.hasUbications')}</label>
					</div>

					<div className={`sl-picks${fractionMode ? ' sl-picks-full' : ''}`}>
						{this.renderCatalog('functions', t('staffingLevels.form.functions'), select_functions)}
						{!fractionMode &&
							this.renderCatalog('shifts', t('staffingLevels.form.shifts'), attendance_shifts)}
					</div>
					{fractionMode && (
						<div className="sl-fraction-bar">
							<div className="sl-fraction-field">
								<label htmlFor="fraction-start">{t('staffingLevels.form.windowStart')}</label>
								<TimeInputWithArrows
									key={`fraction-start-${fractionStartEpoch || 0}`}
									id="fraction-start"
									value={fractionStart}
									placeholder="HH:mm"
									showDecorators={false}
									selectOnFocus
									nextInputId="fraction-end"
									onChange={(event) => this.onFractionClockChange('fractionStart', event)}
									onBlur={(event) => this.onFractionClockBlur('fractionStart', event)}
								/>
							</div>
							<div className="sl-fraction-field">
								<label htmlFor="fraction-end">{t('staffingLevels.form.windowEnd')}</label>
								<TimeInputWithArrows
									key={`fraction-end-${fractionEndEpoch || 0}`}
									id="fraction-end"
									value={fractionEnd}
									placeholder="HH:mm"
									showDecorators={false}
									selectOnFocus
									onChange={(event) => this.onFractionClockChange('fractionEnd', event)}
									onBlur={(event) => this.onFractionClockBlur('fractionEnd', event)}
								/>
							</div>
							<div className="sl-fraction-field">
								<span>{t('staffingLevels.form.granularity')}</span>
								<div className="sl-fraction-steps" role="group">
									{[60, 30, 15].map((step) => (
										<button
											key={step}
											type="button"
											className={`sl-mode${fractionMinutes === step ? ' is-active' : ''}`}
											aria-pressed={fractionMinutes === step}
											onClick={() => this.setFractionWindow({ fractionMinutes: step })}
										>
											{t(
												step === 60
													? 'staffingLevels.form.hour1'
													: step === 30
														? 'staffingLevels.form.minutes30'
														: 'staffingLevels.form.minutes15'
											)}
										</button>
									))}
								</div>
							</div>
						</div>
					)}
					{hasUbications && (
						<div className="sl-picks sl-picks-full">
							{this.renderCatalog('ubications', t('staffingLevels.form.ubications'), locationCatalog)}
						</div>
					)}

					{ready && active && (
						<>
							<div className="sl-tabs" role="tablist">
								{tabs.map((fn) => {
									const total = functionTotal(staffing_level.needs, fn.id);
									const isActive = fn.id === active.id;
									return (
										<button
											type="button"
											key={fn.id}
											role="tab"
											aria-selected={isActive}
											className={`sl-tab${isActive ? ' is-active' : ''}`}
											onClick={() => this.setState({ activeFunctionId: fn.id, menu: null, editing: null })}
										>
											{fn.name}
											<span className="sl-tab-count">
												{t('staffingLevels.form.peopleShort', { count: total })}
											</span>
										</button>
									);
								})}
							</div>

							{this.renderAssign()}
							{this.renderGrid(active, select_day_types)}
						</>
					)}

					{!ready && (
						<p className="info-text sl-hint">
							<FiInfo className="info-icon" />{' '}
							{fractionMode && !(fractions || []).length
								? t('staffingLevels.form.invalidWindow')
								: hasUbications &&
									  selected_functions.length > 0 &&
									  (fractionMode || selected_shifts.length > 0)
									? t('staffingLevels.form.selectUbicationToStart')
									: fractionMode
										? t('staffingLevels.form.selectFractionsToStart')
										: t('staffingLevels.form.selectToStart')}
						</p>
					)}

					{errors.needs && <div className="invalid-feedback d-block">{errors.needs}</div>}
				</div>

				<div className="modal-footer">
					<button type="button" onClick={this.props.handleClose} className="btn sl-cancel">
						{t('common.cancel')}
					</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={t('common.save')}
						loadingText={t('common.saving')}
					/>
				</div>
				{this.renderMenu()}
			</form>
			{pendingEditorMode && (
				<ReactModal
					isOpen
					onRequestClose={this.cancelEditorMode}
					ariaHideApp={false}
					overlayClassName="modal fade show modal-stacked"
					bodyOpenClassName="modal-open"
					className="modal-dialog modal-dialog-centered"
					shouldCloseOnOverlayClick={false}
				>
					<ConfirmModal
						title={t('staffingLevels.form.switchModeTitle')}
						message={t(
							pendingEditorMode === 'shift'
								? 'staffingLevels.form.switchModeToShift'
								: 'staffingLevels.form.switchModeToFraction'
						)}
						style={{ width: '480px', maxWidth: 'calc(100vw - 32px)' }}
						closeModal={this.cancelEditorMode}
						confirmAction={this.confirmEditorMode}
					/>
				</ReactModal>
			)}
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.groupsReducer,
		...reducers.calendarsReducer,
		...reducers.functionsReducer,
		...reducers.shiftsReducer,
		...reducers.ubicationsReducer,
		select_time_types: reducers.timesReducer.select_time_types,
		default_time_type: reducers.timesReducer.default_time_type,
		loading: reducers.groupsReducer.loading,
	};
};

export default connect(mapStateToProps, {
	...groupsActions,
	getSelectableDayTypes: calendarsActions.getSelectableDayTypes,
	getAllUbications: ubicationsActions.getAllUbications,
	getSelectableTimeTypes: timesActions.getSelectableTimeTypes,
	getDefaultTimeType: timesActions.getDefaultTimeType,
})(withTranslation()(StaffingLevelEdit));
